import React, { useEffect, useState } from "react";
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import Slider from '@mui/material/Slider';
import Box from '@mui/material/Box';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Snackbar from '@mui/material/Snackbar';


import { db, firebase_update_device_setting} from "../firebase";


const styles = {
  dial: {
    width: `auto`,
    height: `auto`,
    color: "#000",
    border: "0.5px solid #fff",
    padding: "2px"
  },
  title: {
    fontSize: "1em",
    color: "#000"
  }
};



const VaporizerSetting = ({deviceId, hardware_status, max_value }) => {
    const [hardwareInstall, setHardwareInstall] = useState(hardware_status=='installed');
    const [openChangeSnackbar, setOpenChangeSnackbar] = useState(false);
    const [changeMessage, setChangeMessage] = useState();


    const handleHardwareInstallChange = (event) => {
      if(event.target.checked)
      {
          firebase_update_device_setting(deviceId + '/sensor_info/vaporizer/hardware_status', "installed");
          setChangeMessage("Vaporizer hardware has been installed.")
      }
      else
      {
          firebase_update_device_setting(deviceId + '/sensor_info/vaporizer/hardware_status', "not_installed");
          setChangeMessage("Vaporizer hardware has not been installed.")
      }
      setHardwareInstall(event.target.checked);
      setOpenChangeSnackbar(true);
  }

  const handleCloseChangeMessageSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenChangeSnackbar(false);
  };
    return (
            <Stack direction="column" width="100%">       
                <Box sx={{ width: "100%", pb: 3}}>
                <FormGroup>
                    <FormControlLabel control={<Switch disabled={sessionStorage.getItem('power_user')=="false"} checked={hardwareInstall} />} label={hardwareInstall ? "Installed" : "Not Installed"} onChange={handleHardwareInstallChange} />
                </FormGroup>
                </Box>                       
                <Snackbar
                  open={openChangeSnackbar}
                  autoHideDuration={6000}
                  onClose={handleCloseChangeMessageSnackbar}
                  message={changeMessage}
                />                
            </Stack>
  );
};

export default VaporizerSetting;
